/** @format */

import axios from "axios";

export interface ResourcePageJSON {
  title: string;
}

const fetchJSON = (url: string) => {
  return axios.get(url);
};

// const fetchJSONP = (url: string) =>
//   new Promise<{ data: ResourcePageJSON }>((resolve, reject) => {
//     import('jsonp').then(({ default: jsonp }) => {
//       jsonp(url, { name: 'jsonCallback', timeout: 3000 }, (err, json) => {
//         err ? reject(err) : resolve({ data: json });
//       });
//     });
//   });

export const fetchResource = (resourceId: string) => {
  const apiUrl = process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/`
    : `${process.env.PUBLIC_URL}/json/`;
  const doFetch = (url: string) => fetchJSON(url);
  return doFetch(`${apiUrl}${resourceId.toLowerCase()}.json`);
};
